import { defineStore } from 'pinia'

interface DemoState {
  isActive: boolean
}

export const useDemoStore = defineStore('demo', {
  state: (): DemoState => ({
    isActive: false,
  }),
  actions: {
    setActive(active: boolean) {
      this.isActive = active
    },
  },
})
